// https://github.com/junipersquare/main/blob/3f1ae48ce2a653a36709e9cc8e12de6f16f7990d/jsq/client/src/apps/portal/Portal/SingleManager/utils.ts#L21-L32
export const capitalizeEachWord = (sentence: string | null | undefined) => {
  if (!sentence) {
    return "";
  }
  const capitalizeNonPrepositionWord = (word: string) => {
    if (/^(?:of|on|at|in|to|by|against|with(?:in)?)$/i.test(word)) {
      return word.toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
  };
  return sentence.split(/\s+/).map(capitalizeNonPrepositionWord).join(" ");
};

/**
 * Capitalizes the first letter of a string and lowercases the rest.
 * Returns empty string for null or undefined inputs.
 */
export const capitalizeFirstLetter = (str: string | null | undefined) => {
  if (!str) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
};
